import { useState, useCallback } from "react"

export const useTick = (): [number, () => void] => {
  const [tick, setTick] = useState(0);
  const doTick = useCallback(() => setTick(prev => ++prev), []);
  return [tick, doTick];
}